import * as React from 'react';
import onClickOutside from 'react-onclickoutside';

import { Input } from '../form/base-atoms/Input';

class Renderer extends React.PureComponent {
  state = {
    tags: [],
    options: [],
    showSuggestions: undefined,
  };

  componentDidMount() {
    const { options, tags } = this.props;
    if ((options, tags)) {
      this.setState({
        options: options.filter((option) => !tags.some((tag) => tag === option.value)),
        tags: options.reduce((options, option) => {
          if (tags.includes(option.value)) {
            options.push(option);
          }
          return options;
        }, []),
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { tags, options } = this.props;
    if (tags && options && tags !== prevProps.tags) {
      this.setState({
        options: options.filter((option) => !tags.some((tag) => tag === option.value)),
        tags: options.reduce((options, option) => {
          if (tags.includes(option.value)) {
            options.push(option);
          }
          return options;
        }, []),
      });
    }
  }

  onInputChange = (e) => {
    const { value } = e.target;
    const { options } = this.props;

    if (!value) {
      this.setState({ options });
      return;
    }

    this.setState({
      options: options.filter((tag) => {
        return tag.label.toLowerCase().includes(value.toLowerCase());
      }),
    });
  };

  onInputFocus = () => {
    this.setState({ showSuggestions: true });
  };

  handleClickOutside = (event) => {
    this.setState({ showSuggestions: false });
  };

  onRemoveTag = (tag) => {
    const { options, onChange } = this.props;
    const { tags: oldTags } = this.state;
    const tags = oldTags.reduce((tags, current) => {
      if (current.value !== tag.value) {
        tags.push(current);
      }
      return tags;
    }, []);

    this.setState(
      {
        tags,
        options: options.filter((option) => !tags.some((tag) => tag.value === option.value)),
      },
      () =>
        onChange(
          tags.reduce((tags, tag) => {
            tags.push(tag.value);
            return tags;
          }, []),
        ),
    );
  };

  onSelectOption = (option) => {
    const { tags: oldTags, options } = this.state;
    const { onChange } = this.props;
    const tags = [...oldTags, option];
    this.setState(
      {
        showSuggestions: false,
        tags,
        options: options.filter((option) => !tags.some((tag) => tag.value === option.value)),
      },
      () =>
        onChange(
          tags.reduce((tags, tag) => {
            tags.push(tag.value);
            return tags;
          }, []),
        ),
    );
  };

  render() {
    const { tags, options, showSuggestions } = this.state;
    const { placeholder } = this.props;
    return tags && options ? (
      <div className="tags-select">
        <div className="tags-select__upper">
          {tags.map((tag) => (
            <div key={tag.value} className="tags-select__tag">
              {tag.label}
              <span className="tags-select__tag__remove" onClick={() => this.onRemoveTag(tag)}>
                x
              </span>
            </div>
          ))}
          <Input
            placeholder={placeholder}
            onChange={this.onInputChange}
            onFocus={this.onInputFocus}
            className="tags-select__input"
          />
        </div>
        {showSuggestions && (
          <div className="tags-select__suggestions">
            {options.map((option) => (
              <div key={option.value} onClick={() => this.onSelectOption(option)} className="tags-select__option">
                {option.label}
                <span className="tags-select__option__add">+</span>
              </div>
            ))}
          </div>
        )}
      </div>
    ) : null;
  }
}

const clickOutsideConfig = {
  excludeScrollbar: true,
};

export const TagsSelect = onClickOutside(Renderer, clickOutsideConfig);
